import React, { memo } from "react";
import QalqiLogo from "./QalqiLogo";
import NavigationMobile from "./NavigationMobile";
import Navigation from "./Navigation";
import { SlideKey } from "../config/slides";

export interface GlobalHeaderProps {
    activeSlide?: SlideKey;
}

export const GlobalHeader: React.FC<GlobalHeaderProps> = ({ activeSlide }) => {
    return (
        <>
            {/* Mobile Navigation */}
            <div className="mobile-only" style={{ width: "100%", pointerEvents: "all", position: "fixed", top: 0, left: 0, zIndex: 100 }}>
                <NavigationMobile activeSlide={activeSlide} />
            </div>

            {/* Desktop Navigation */}
            <div
                className="desktop-only"
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    zIndex: 100,
                    padding: "20px 40px",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "rgba(255, 255, 255, 0.4)",
                    backdropFilter: "blur(10px)",
                    WebkitBackdropFilter: "blur(10px)",
                    borderBottom: "1px solid rgba(255, 255, 255, 0.3)",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                }}
            >
                <a href="/" style={{ pointerEvents: "all" }}>
                    <QalqiLogo activeSlide={activeSlide} />
                </a>
                <div style={{ flex: "1 1 0%", display: "flex", gap: "2em" }}></div>
                <Navigation activeSlide={activeSlide} />
            </div>
        </>
    );
};

export default memo(GlobalHeader);
